import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { FrameworkService } from './framework.service';
import { SysGlobals } from './sysglobals';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    private _languageSubject = new ReplaySubject<string>(1);
    public Language$ = this._languageSubject.asObservable();

    constructor(private frameworkService: FrameworkService) {}

    SetLanguage(language: string) {
        if (language == undefined) return;

        if (SysGlobals.Language !== language) {
            SysGlobals.Language = language; // TODO: REMOVE THAT
            localStorage.setItem("Language", language);
    
            this.frameworkService.InitLanguage();
            this.frameworkService.InitializeDevExpress();
        }

        this._languageSubject.next(language);
    }
}